import { Box, Stack, Typography } from '@mui/material';

import { ExportConnectionEnum } from '@verantos-dev/data-access-export-connections';
import {
  ApiWorkflowDialog,
  Dropdown,
  TextField,
  TruncatedTooltip,
} from '@verantos-dev/shared-components';
import { theme } from '@verantos-dev/shared-styles';

import { ExportCohortModalSubmitted } from './ExportCohortModalSubmitted';
import { useExportCohortModal } from '../../hooks/useExportCohortModal';
import { useExportCohortModalStrings } from '../../hooks/useExportCohortModalStrings';

export const ExportCohortModal = () => {
  const { contentMessages, dialogMessages } = useExportCohortModalStrings();
  const {
    onClose,
    onSubmit,
    isSubmitting,
    exportCohortError,
    isInitialLoading,
    isValidForSubmit,

    projectName,
    cohortName,
    exportLocationOptions,
    exportLocationId,
    onChangeExportLocationId,
    selectedExportLocation,

    schemaName,
    onChangeSchemaName,
  } = useExportCohortModal();

  return (
    <ApiWorkflowDialog
      id="exportCohortModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      submittingError={exportCohortError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      successCountdownTime={-1}
      renderSubmitted={
        <ExportCohortModalSubmitted
          projectName={projectName}
          cohortName={cohortName}
          schemaName={schemaName}
          selectedExportLocation={selectedExportLocation}
        />
      }
    >
      <Stack direction={'column'} gap={6}>
        <Typography variant="body1">{contentMessages.description}</Typography>
        <Box paddingLeft={3} paddingBlock={1} display={'flex'} flexDirection={'column'} gap={1}>
          <Typography variant="body2" fontSize={'12px'} color={theme.palette.text.secondary}>
            {contentMessages.projectName}
          </Typography>
          <TruncatedTooltip id="export-cohort-project-name-tooltip" title={projectName}>
            <Typography
              variant="body1"
              fontSize={'16px'}
              lineHeight={'24px'}
              color={theme.palette.text.primary}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              whiteSpace={'nowrap'}
            >
              {projectName}
            </Typography>
          </TruncatedTooltip>
        </Box>
        <Box paddingLeft={3} paddingBlock={1} display={'flex'} flexDirection={'column'} gap={1}>
          <Typography variant="body2" fontSize={'12px'} color={theme.palette.text.secondary}>
            {contentMessages.cohortName}
          </Typography>
          <TruncatedTooltip id="export-cohort-cohort-name-tooltip" title={cohortName}>
            <Typography
              variant="body1"
              fontSize={'16px'}
              lineHeight={'24px'}
              color={theme.palette.text.primary}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
              whiteSpace={'nowrap'}
            >
              {cohortName}
            </Typography>
          </TruncatedTooltip>
        </Box>
        <Dropdown
          id={'export-connection-location-export-connection'}
          label={contentMessages.exportLocation}
          placeholder={contentMessages.exportLocationPlaceholder}
          width={'auto'}
          options={exportLocationOptions}
          onChange={onChangeExportLocationId}
          value={exportLocationId}
        />
        {selectedExportLocation?.connectionType === ExportConnectionEnum.SNOWFLAKE && (
          <TextField
            id={'snowflake-schema-name-export-connection'}
            displayLabel={contentMessages.schemaName}
            helperText={contentMessages.schemaNameHelptext}
            placeholder={contentMessages.schemaNamePlaceholder}
            value={schemaName}
            onChange={onChangeSchemaName}
            width={552}
          />
        )}
      </Stack>
    </ApiWorkflowDialog>
  );
};
